/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface INetworkConfigModalScope extends ng.IScope {
        element: Models.ITopologyElement;
        gateways: Models.IGateway[];
        modalClose: () => void;
        modalSave: () => void;
        getIdFromHref: (href: string) => number;
        launchNATModal: () => void;
        launchNATModalHelper: () => void;
        isGateway: () => boolean;
        addNetworkInterface: () => void;
        removeNetworkInterface: (index: number) => void;
        getMinimumInterfacesNum: () => number;
    }

    /**
     * NetworkConfigModalController class
     */
    export class NetworkConfigModalController {
        public static templateUrl: string = "decorators/modals/network-config-modal.html";
        public static ID: string = "#id-network-config-modal";
        public static $name: string = "networkConfigModalController";
        public static $inject: string[] = ['$scope',
                                           'ModalService',
                                           'topologyElementService',
                                           'close',
                                           '$timeout',
                                           'element',
                                           'gateways'];

        private $scope: INetworkConfigModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;
        private originalElement: Models.ITopologyElement;

        /**
         * Constructor
         */
        constructor($scope: INetworkConfigModalScope,
                    modalService: ngModal.IModalService,
                    topologyElementService: Services.TopologyElementService,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    $timeout: ng.ITimeoutService,
                    element: Models.ITopologyElement,
                    gateways: Models.IGateway[]) {

            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);

            this.$scope = $scope;
            this.close = close;
            this.$scope.element = element;
            this.originalElement = angular.copy(this.$scope.element);
            this.$scope.gateways = gateways;

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (): void => {
                for (let nic of (this.$scope.element as Models.INetworkNode).networkInterfaces) {
                    if (!Common.Utils.validateIPAddress(nic.ipAddress))
                        return;
                }

                if (this.checkMVPVideoManager(this.$scope.element)) {
                    this.close(this.$scope.element);
                }
            };

            this.$scope.getIdFromHref = (href: string): number => {
                return Common.Utils.idFromHref(href);
            };

            this.$scope.launchNATModal = (): void => {
                if (angular.equals(this.originalElement, this.$scope.element)) {
                    this.$scope.launchNATModalHelper();
                } else {
                    modalService
                        .showModal({
                            templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                            controller: Application.Controllers.ConfirmModalController.$name,
                            inputs: {
                                title: 'SAVE CHANGES?',
                                description: "In order to proceed, you need to save the changes performed over the element.",
                                name: element.name,
                                type: 'information',
                            },
                        })
                        .then((modal: ngModal.IModalObject) => {
                            let modalElem: UIkit.ModalElement =
                                UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                                            { bgclose: false, modal: false, keyboard: false });
                            modalElem.show();
                            modal.close.then((result: Object) => {
                                modalElem.hide();
                                if (result) {
                                    topologyElementService.saveTopologyElement(this.$scope.element)
                                        .then((resultElement: Models.IGateway) => {
                                            this.$scope.element = resultElement;
                                            this.originalElement = angular.copy(this.$scope.element);
                                            this.$scope.launchNATModalHelper();
                                        });
                                }
                            });
                        });
                }
            };

            this.$scope.launchNATModalHelper = (): void => {
                modalService.showModal({
                    templateUrl: Application.Controllers.NATModalController.templateUrl,
                    controller: Application.Controllers.NATModalController.$name,
                    inputs: {
                        gateway: this.$scope.element as Models.Gateway,
                    },
                }).then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.NATModalController.ID,
                                {bgclose: false, modal: false, keyboard: false});
                    modalElem.show();
                    modal.close.then(() => {
                        modalElem.hide();
                    });
                });
            };

            this.$scope.isGateway = (): boolean => {
                return this.$scope.element.class() === Models.TopologyElementType.Gateway;
            };

            this.$scope.addNetworkInterface = (): void => {
                (this.$scope.element as Models.INetworkNode).networkInterfaces.push(Models.NetworkInterface.createDefault());
            };

            this.$scope.removeNetworkInterface = (index: number): void => {
                (this.$scope.element as Models.INetworkNode).networkInterfaces.splice(index, 1);
            };

            this.$scope.getMinimumInterfacesNum = (): number => {
                return (element.href.indexOf("/gateways/") !== -1) ? 2 : 1;
            };
        }

        private checkMVPVideoManager(element: Models.ITopologyElement): boolean {
            let node: Models.INetworkNode = element as Models.INetworkNode;
            if (node.type === undefined ||
                node.type.vendor === undefined ||
                node.type.vendor !== Models.NetworkNodeTypeVendor.MVP)
                return true;
            else {
                let mvpConfig: Models.MVPConfig = node.config as Models.MVPConfig;
                return (!mvpConfig.videoManager ||
                        !mvpConfig.videoManager.enabled ||
                        (mvpConfig.videoManager.host &&
                         mvpConfig.videoManager.host !== '' &&
                         mvpConfig.videoManager.port !== undefined &&
                         Common.Utils.validatePortNum(mvpConfig.videoManager.port))
                       );
            }
        }
    }
}
